/**
 * 五日分时辅视图装饰器
 * 因X轴时间刻度与分时K线有区别，需单独绘制
 */
import {mergeModelData} from '../../../util/index.js';
const model = {
};
const TrendFiveFootDectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _drawAxisX() {
    const {
      top,
      height,
      isFullScreen,
    } = this.state;
    const {axisX} = this.state.data;
    const {
      left,
      width,
      right,
      bottom
    } = this.availArea;
    const {
      top: topRatio,
      sizeRatio,
      fontFamily,
      color
    } = !isFullScreen ? this.option.FootContext.axisX : this.option.FootContext.fullAxisX;
    const ctx = this.context;
    ctx.font = sizeRatio * this.state.baseSize * this.dpr + "px " + fontFamily;
    ctx.textBaseline = "top";
    ctx.textAlign = "center";
    ctx.fillStyle = color;
    const len = axisX.length;
    const { solidColor} = this.option.FootContext;
    // 5日分时的左右边框
    // this._drawSolid({x:0,y:0},{x:0,y:bottom}, this.dpr, solidColor, this.context);
    // this._drawSolid({x:right,y:0},{x:right,y:bottom}, this.dpr, solidColor, this.context);
    if (len === 0) {
      return;
    }
    const step = width / 5;
    const start = left + step / 2;
    const topY = top + height * topRatio;
    for (let i = 0; i < len; i++) {
      ctx.beginPath();
      let leftX = start + step * i;
      ctx.fillText(axisX[i], leftX, topY);
    }
  }
}
export default TrendFiveFootDectorator;
